const closedownlist = {
  path: 'closedownlist',
  component: resolve => require(['@/pages/admin/aftersales/closedownlist'], resolve)
}

export default closedownlist
